import { IContactFormDataForAPI, IContactPayloadForAPI } from 'src/utils/CommonHelpers/ContactAPIOperations/types';
import {
  addCalendarFields,
  addHomePropertyFields,
  addOccupantFields,
  addRealtorFields,
  addServiceManagerFields,
  addServiceProviderFields,
  addFieldsForUsersThatNeedACompanyName,
  createBasePayload,
} from 'src/utils/CommonHelpers/ContactAPIOperations/sharedContactPayloadBuilderHelpers';

const buildPropertiesContactsPayload = (
  formData: IContactFormDataForAPI,
  propertyId: string,
  editingExistingContactInTable: boolean = false,
  appendingNewContactToExistingProperty: boolean,
  formOptions: any,
  adminUserId: any
): IContactPayloadForAPI => {
  let payload: Partial<IContactPayloadForAPI> = createBasePayload(
    formData,
    adminUserId,
    formOptions,
    'Property'
  );
  
  payload = addServiceProviderFields(payload, formData);
  payload = addHomePropertyFields(payload, formData);
  payload = addRealtorFields(payload, formData);
  payload = addOccupantFields(payload, formData);
  payload = addServiceManagerFields(payload, formData);
  payload = addCalendarFields(payload, formData);
  payload = addFieldsForUsersThatNeedACompanyName(payload, formData)
  
  // Properties-specific handling for Property Developers and Service Managers.
  if (
    formData.userRole === 'Property Developer' ||
    formData.userRole === 'Service Manager'
  ) {
    // DON'T DELETE PROPERTIES AND SUITES IF WE ARE APPENDING A CONTACT TO AN EXISTING PROPERTY.
    if (
      editingExistingContactInTable &&
      !appendingNewContactToExistingProperty
    ) {
      // 🛑 CRITICAL: Remove array fields to skip backend's "Clear and Recreate" logic.
      // This prevents data loss (wiping out other property assignments) and duplicate records.
      delete payload.Properties;
      delete payload.Suites;
    }
    
    // DON'T ADD A PROPERTY ID TO THE PAYLOAD IF WE ARE JUST ADDING AN EXISTING CONTACT TO A EXISTING PROPERTY.
    if (!appendingNewContactToExistingProperty) {
      payload.PropertyId = propertyId;
    }
  }
  
  // TODO: Temporary workaround - remove when API is fixed
  // https://app.asana.com/1/41213529744312/project/1208712340140532/task/1211760218229163
  delete payload.isPrimaryPropertyDeveloperContact;
  delete payload.IsPrimaryContact;
  
  return payload as IContactPayloadForAPI;
};

export { buildPropertiesContactsPayload }